module.exports = __webpack_public_path__ + "img/download-white.238630d0.svg";